import styled from 'styled-components';

import { mediaBreakpoint } from '../../utils/mediaBreakpoint';

const AlignWithSpace = styled.div`
    ${mediaBreakpoint.up('md')} {
        justify-content: space-between;
        display: flex;
        padding-bottom: ${({ theme }) => theme.Spacing.spacing1x};
    }
`;

export default AlignWithSpace;
